export default __webpack_public_path__ + "images/c14839c11a6418335b2fab2b7aaf7e7e-ios-homescreen-icon.svg";